<template>
<div class="clearfix">
    <div class="nav float-right" v-show="isLoggedIn === false">
      <router-link to="/login">Login</router-link> |
      <router-link to="/signup">SignUp</router-link>
    </div>
    <div class="nav float-right" v-show="isLoggedIn === true">
      Hi {{first_name}} |
      <router-link tag="a" to="/"> Home</router-link> ｜
      <router-link tag="a" to="/demo"> Demo</router-link> ｜
      <router-link tag="a" to="/logout"> Logout</router-link>
    </div>
  </div>
</template>

<style>
.nav {
  padding: 10px;
  text-align:end;
}

.nav a {
  font-weight: bold;
  color: #2c3e50;
}

.nav a:hover,
.nav a.router-link-exact-active {
  color: #379683;
}

</style>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isLoggedIn: false,
      first_name: null,
    };
  },
  created() {
    if (localStorage.first_name) {
      this.isLoggedIn = true;
      this.first_name = localStorage.first_name;
    }
  },
};
</script>
